import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { MediaUpdateItem, MediaUpdates } from '../types';
import { COPY, mediaAvailableText } from '../presentationCopy';
import { PRES, TYPE } from '../chrome';

interface MediaUpdatesBannerProps {
  updates: MediaUpdates;
  onAccept: (objectIds: Array<{ slideId: string; objectId: string }>) => void;
  onDismissAvailable: () => void;
  onReveal?: (item: MediaUpdateItem) => void;
}

const MediaUpdatesBanner: React.FC<MediaUpdatesBannerProps> = ({
  updates, onAccept, onDismissAvailable, onReveal,
}) => {
  if (!updates.applied.length && !updates.available.length) return null;
  return (
    <Box sx={{ px: 1.5, pt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
      {!!updates.applied.length && (
        <Alert severity="info">
          {updates.applied.length} {COPY.mediaApplied}
          <Box component="ul" sx={{ m: 0, pl: 2 }}>
            {updates.applied.map((item) => (
              <li key={`${item.slideId}-${item.objectId}`}>{item.title}</li>
            ))}
          </Box>
        </Alert>
      )}
      {!!updates.available.length && (
        <Alert
          severity="warning"
          action={(
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button color="inherit" size="small" onClick={() => onAccept(updates.available)}>
                {COPY.updateFromAthena}
              </Button>
              <Button color="inherit" size="small" onClick={onDismissAvailable}>
                {COPY.keepPin}
              </Button>
            </Box>
          )}
        >
          <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textPrimary }}>
            {mediaAvailableText(updates.available.length)}
          </Typography>
          <Box component="ul" sx={{ m: 0, mt: 0.75, pl: 2 }}>
            {updates.available.map((item) => (
              <Box
                component="li"
                key={`${item.slideId}-${item.objectId}`}
                sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
              >
                <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textPrimary }}>
                  {item.title}
                </Typography>
                {onReveal && (
                  <Button
                    color="inherit"
                    size="small"
                    onClick={() => onReveal(item)}
                    sx={{ textTransform: 'none', minWidth: 0, px: 0.5 }}
                  >
                    {COPY.showBlock}
                  </Button>
                )}
              </Box>
            ))}
          </Box>
        </Alert>
      )}
    </Box>
  );
};

export default MediaUpdatesBanner;
